import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@/lib/utils";

/**
 * Popover — anchored floating panel built on Radix.
 *
 * Use for filter pills, date pickers, custom selects, info bubbles.
 *
 * @example
 *   <Popover>
 *     <PopoverTrigger asChild>
 *       <Button variant="secondary">Filter</Button>
 *     </PopoverTrigger>
 *     <PopoverContent align="start">
 *       ...
 *     </PopoverContent>
 *   </Popover>
 */
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef(
  (
    { className, align = "center", sideOffset = 6, container, ...props },
    ref,
  ) => (
    <PopoverPrimitive.Portal container={container}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-[28rem] p-[1.2rem] outline-none pointer-events-auto",
          "bg-white border border-gray rounded-[1.2rem] shadow-lg",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
